(function() {
    angular
        .module('app')
        .factory('cache', cache);

    function cache() {
        var service = this;
        service.save = save;
        service.load = load;
        service.exists = exists;
        service.reset = reset;
        service.equals = equals;
        service.clear = clear;
        service.getSetting = getSetting;
        service.setSetting = setSetting;

        function save(name, data){
            sessionStorage.setItem(name, angular.toJson(data));
        }

        function load(name) {
            return sessionStorage.getItem(name) == "undefined" ? undefined : isNaN(sessionStorage.getItem(name)) ? JSON.parse(sessionStorage.getItem(name)) : parseInt(sessionStorage.getItem(name));
        }

        function exists(name) {
            return sessionStorage.getItem(name) !== undefined && sessionStorage.getItem(name) !== null;
        }

        function equals(name, data){
            return angular.toJson(data) == sessionStorage.getItem(name);
        }

        function reset(name) {
            sessionStorage.removeItem(name);
        }

        function clear() {
            sessionStorage.clear();
        }

        function getSetting(name) {
            return localStorage.getItem(name) == "undefined" || localStorage.getItem(name) == null ? undefined : isNaN(localStorage.getItem(name)) ? JSON.parse(localStorage.getItem(name)) : parseInt(localStorage.getItem(name));
        }

        function setSetting(name, data) {
            localStorage.setItem(name, angular.toJson(data));
        }

        return service;
    }
})();